// Removed Ant Design icon import
// Removed Alert, Menu, Modal, Tooltip imports
import { useState } from 'react' // Added useState
import { useLocalization } from '../../../localization'

import { faExternalLinkAlt, faCopy, faTrashAlt } from '@fortawesome/free-solid-svg-icons' // Added faCopy, faTrashAlt
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Removed Text import (no longer used)
import { API } from 'aws-amplify'
import moment from 'moment'
// Added CB component imports
import { CBAlert, CBModal, CBButton } from '../../core/components/cbd'; // Assuming CBAlert, CBModal, CBButton are in cbd
import { CBMenu, CBMenuItem } from '../../core/components/CBDropdown'; // Use the Menu/MenuItem from CBDropdown
import { CBTooltip } from '../../core/components/CBTooltip';
import { useNavigate } from 'react-router-dom'
import { ReactComponent as  Book } from '../../../images/svg/book.svg'
import { useGlobalState } from '../../../store'
import { colorNeutralDark, colorPrimary } from '../../../utils/colors' // Import colorPrimary
import {
  CBHeader,
  CBList,
  CBListItem
} from '../../core/components/cbd'
import ColorPicker from '../../syncs/components/ColorPicker'

const languages = (t) => ({ // Wrap in a function to access t
  "en": t('scheduler.lang_en'),
  "es": t('scheduler.lang_es'),
  "de": t('scheduler.lang_de'),
  "default": t('scheduler.lang_default'),
  "fr": t('scheduler.lang_fr'),
  "pt": t('scheduler.lang_pt'),
  "ja": t('scheduler.lang_ja'),
});
const ScheduleItem = ({ item, preview = false, showClone = true }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const [license] = useGlobalState('license')
  const [expanded, setExpanded] = useState(preview)
  // State for delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // State for copy feedback
  const [copied, setCopied] = useState(false);

  // Handler for copy to clipboard
  const handleCopy = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      // Optionally show an error message to the user
    });
  };


  // Handler for delete confirmation
  const handleDeleteConfirm = async () => {
    setShowDeleteModal(false); // Close modal
    try {
      await API.del('schedules', '/schedules', {
        body: {
          id: item.id,
        },
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dashboardEvent',
        category: 'userActivity',
        action: 'deleteScheduler',
        label: license.userId,
        email: license.email,
      });
      window.location.reload(); // Consider state update instead
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete scheduler."); // Simple error feedback
    }
  };

  // Function to show modal
  function showDeleteConfirm() {
    setShowDeleteModal(true);
  }

  const duplicate = async () => {
    await API.post('schedules', '/schedules?duplicate=true', {
      body: {
        id: item.id,
      },
    })

    window.location.reload()
  }
  const handleClick = (e) => {
    if (e === '0') {
      navigate(`/dashboard/schedules/${item.id}/edit`)
    } else if (e === '1') {
      showDeleteConfirm()
    } else if (e === '2') {
      if(showClone) {
        duplicate()
      } else {
        alert(t('scheduler.clone_limit_alert'))
      }

    }
  }

  // Replaced Ant Menu with CBMenu/CBMenuItem
  const menuItems = (
    <CBMenu onClick={({ key }) => handleClick(key)}> {/* Pass key directly */}
      <CBMenuItem key="0">
        <div className="flex gap-x-2 items-center"> {/* Reduced gap */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5"> {/* Smaller icon */}
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
          </svg>
          {t('scheduler.edit_button')}
        </div>
      </CBMenuItem>
      <CBMenuItem key="2">
        <div className="flex gap-x-2 items-center"> {/* Reduced gap */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5"> {/* Smaller icon */}
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
          </svg>
          {t('scheduler.clone_button')}
        </div>
      </CBMenuItem>
      <CBMenuItem key="1" className="text-red-600"> {/* Added text color */}
        <div className="flex gap-x-2 items-center"> {/* Reduced gap */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5"> {/* Smaller icon */}
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
          {t('common.delete_button')}
        </div>
      </CBMenuItem>
    </CBMenu>
  );

  // Keep renderMenu function, but use CB components if needed elsewhere, or remove if unused
  function renderMenu(){
    // This function seems redundant now with the menuItems constant, unless used differently
    return <div className="flex flex-row gap-2">

      <div key="0" onClick={e=> handleClick("0")}className="menu-thing">
        <div className="flex gap-x-2 items-center">
          {' '}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
            />
          </svg>
          {t('scheduler.edit_button')}
        </div>
      </div>

        <div key="2" onClick={e=> handleClick("2")} className="menu-thing">
          <div className="flex gap-x-2 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
              />
            </svg>
            {t('scheduler.clone_button')}
          </div>
        </div>

      <div key="1" onClick={e=> handleClick("1")} className="menu-thing">
        <div className="flex gap-x-2 items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
          {t('common.delete_button')}
        </div>
      </div>
    </div>
  }

  {
    /* <Select.Option value="7">1 week</Select.Option>
            <Select.Option value="14">2 weeks</Select.Option>
            <Select.Option value="21">3 weeks</Select.Option>
            <Select.Option value="30">1 month</Select.Option>
            <Select.Option value="60">2 months</Select.Option>
            <Select.Option value="90">3 months</Select.Option>
            <Select.Option value="120">4 months</Select.Option>
            <Select.Option value="150">5 months</Select.Option>
            <Select.Option value="180">6 months</Select.Option> */
  }
  function convertRang(string) {
    var str = ''


        switch (string) {
          case '7':
            str = t('scheduler.duration_1_week')
            break
          case '14':
            str = t('scheduler.duration_2_weeks')
            break
          case '21':
            str = t('scheduler.duration_3_weeks')
            break
          case '30':
            str = t('scheduler.duration_1_month')
            break
          case '60':
            str = t('scheduler.duration_2_months')
            break
          case '90':
            str = t('scheduler.duration_3_months')
            break
          case '120':
            str = t('scheduler.duration_4_months')
            break
          case '150':
            str = t('scheduler.duration_5_months')
            break
          case '180':
            str = t('scheduler.duration_6_months')
      default:
        break
    }
    return str
  }

  function convertToMinHourThing(string) {
    var str = ''

    switch (string) {
      case 0:
        str = t('scheduler.lead_time_0_min')
        break
      case 5:
        str = t('scheduler.lead_time_5_min')
        break
      case 10:
        str = t('scheduler.lead_time_10_min')
        break
      case 15:
        str = t('scheduler.lead_time_15_min')
        break
      case 30:
        str = t('scheduler.lead_time_30_min')
        break
      case 45:
        str = t('scheduler.lead_time_45_min')
        break
      case 60:
        str = t('scheduler.lead_time_1_hour')
        break
      case 90:
        str = t('scheduler.lead_time_90_min')
        break
      case 120:
        str = t('scheduler.lead_time_2_hours')
        break
      case 180:
        str = t('scheduler.lead_time_3_hours')
        break
      case 240:
        str = t('scheduler.lead_time_4_hours')
        break
      case 480:
        str = t('scheduler.lead_time_8_hours')
        break
      case 720:
        str = t('scheduler.lead_time_12_hours')
        break
      case 1440:
        str = t('scheduler.lead_time_1_day') // Assuming '1 day' key exists or is needed
        break
      case 2880:
        str = t('scheduler.lead_time_2_days') // Assuming '2 days' key exists or is needed
        break
      case 4320:
        str = t('scheduler.lead_time_3_days')
        break
      case 10080:
        str = t('scheduler.lead_time_duration_1_week')
        break
      default:
        break
    }
    return str
  }

  return (
    <>
      <div className="rounded-sm border border-neutral_1 mt-2 mb-12 flex flex-col shadow-md">
        <div className="flex flex-col pl-2 pr-2 lg:pl-4 lg:pr-4 pb-4">
          <div>
            <CBHeader
              label={
                <div>
                  {item.label != '' && item.label != null
                    ? item.label
                    : item.displayName}{' '}
                  {item.greeting && `- ${item.greeting}`}
                </div>
              }
              icon={<Book></Book>}
              menu={
                <></>
              }
            ></CBHeader>
          </div>
          <div className="flex flex-row items-center">
            <div>
              <div className="text-neutral_4">
                {}
                <div className="font-sarabun text-neutral_4 text-lg">
                  {item.ownerName} - {item.ownerEmail}
                </div>
                {preview && item.alias != '' && (
                  <div className="font-sarabun text-neutral_4 mt-2 mb-2 text-lg bg-white border-2 border-neutral_1">
                    {' '}
                    {`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${license.vanityAlias}/` +
                      (item.alias != '__me__' ? item.alias : '')}
                  </div>
                )}
                {!preview && (
                  <div>
                    {license.vanityAlias == '' && (
                      <div className="flex items-center space-x-2">
                        <span className="text-sm text-gray-700 break-all">{`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${item.id}`}</span>
                        <CBTooltip title={copied ? t('common.copied') : t('common.copy_link')}> {/* Conditional title */}
                          {(() => { // IIFE to define icon variable
                            const copyIcon = <FontAwesomeIcon icon={faCopy} style={{ color: '#005B99' }} />; // Changed to dark blue
                            return (
                              <CBButton
                                type="text" // Use text button for subtle icon look
                                icon={copyIcon} // Pass variable to icon prop
                                onClick={() => handleCopy(`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${item.id}`)}
                                className="p-1" // Adjust padding if needed
                              />
                            );
                          })()}
                        </CBTooltip>
                        <CBTooltip title={t('scheduler.open_link_tooltip')}>
                          <a
                            rel="noopener noreferrer"
                            target="_blank"
                            href={`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${item.id}`}
                            className="text-blue-600 hover:text-blue-800"
                          >
                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                          </a>
                        </CBTooltip>
                      </div>
                    )}
                    {license.vanityAlias != '' &&
                      (!item.alias || item.alias == '') && (
                        <div className="flex items-center space-x-2">
                          <span className="text-sm text-gray-700 break-all">{`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${item.id}`}</span>
                          <CBTooltip title={copied ? t('common.copied') : t('common.copy_link')}> {/* Conditional title */}
                            {(() => { // IIFE to define icon variable
                              const copyIcon = <FontAwesomeIcon icon={faCopy} style={{ color: '#005B99' }}  />; // Changed to dark blue
                              return (
                                <CBButton
                                  type="text"
                                  icon={copyIcon} // Pass variable to icon prop
                                  onClick={() => handleCopy(`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${item.id}`)}
                                  className="p-1" // Removed redundant color class from button
                                />
                              );
                            })()}
                          </CBTooltip>
                          <CBTooltip title={t('scheduler.open_link_tooltip')}>
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href={`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${item.id}`}
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <FontAwesomeIcon icon={faExternalLinkAlt} />
                            </a>
                          </CBTooltip>
                        </div>
                      )}
                    {license.vanityAlias != '' &&
                      !(!item.alias || item.alias == '') && (
                        <div className="flex items-center space-x-2">
                          <span className="text-sm text-gray-700 break-all">
                            {`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${license.vanityAlias}/` +
                              (item.alias != '__me__' ? item.alias : '')}
                          </span>
                          <CBTooltip title={copied ? t('common.copied') : t('common.copy_link')}> {/* Conditional title */}
                            {(() => { // IIFE to define icon variable
                              const copyIcon = <FontAwesomeIcon icon={faCopy} style={{ color: '#005B99' }} />; // Changed to dark blue
                              return (
                                <CBButton
                                  type="text"
                                  icon={copyIcon} // Pass variable to icon prop
                                  onClick={() => handleCopy(`${process.env.REACT_APP_BOOKING_LINK_URL}/book/${license.vanityAlias}/` + (item.alias != '__me__' ? item.alias : ''))}
                                  className="p-1" // Adjust padding if needed
                                />
                              );
                            })()}
                          </CBTooltip>
                          <CBTooltip title={t('scheduler.open_link_tooltip')}>
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href={
                                `${process.env.REACT_APP_BOOKING_LINK_URL}/book/${license.vanityAlias}/` +
                                (item.alias != '__me__' ? item.alias : '')
                              }
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <FontAwesomeIcon icon={faExternalLinkAlt} />
                            </a>
                          </CBTooltip>
                        </div>
                      )}
                  </div>
                )}

                {!preview &&
                  license.vanityAlias != '' &&
                  (!item.alias || item.alias == '') && (
                     // Replaced Alert with CBAlert, wrapped in div for click handling
                     <div className="cursor-pointer mt-2" onClick={(e) => navigate(`/dashboard/schedules/${item.id}/edit`)}>
                      <CBAlert
                        // showIcon - Handled by CBAlert variant
                        variant="info" // Map type
                        message={t('scheduler.configure_custom_url_alert')}
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-neutral_1 p-1 lg:p-4 flex flex-col justify-center">
          {item.destinationColor != 'default' && (
            <CBListItem
              border={false}
              icon={
                <ColorPicker
                  type={item.type}
                  color={item.destinationColor}
                  preview={true}
                ></ColorPicker>
              }
            >
              {t('sync.color')} {/* Reusing sync key */}
            </CBListItem>
          )}
          <CBListItem
            border={false}
            icon={
              <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                {item.meetingIncrement
                  .map((e) => parseInt(e))
                  .sort(function (a, b) {
                    return a - b
                  })
                  .map((e) => e.toString())
                  .join(',')}
              </div>
            }
          >
            {t('scheduler.meeting_length_label')}
          </CBListItem>
          {item.startCrement != 0 && (
            <CBListItem
              border={false}
              icon={
                <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                  {`${item.startCrement} min`}
                </div>
              }
            >
              {t('scheduler.start_increment_label')}
            </CBListItem>
          )}
          {item.defaultTime && item.defaultTime != -1  && (
            <CBListItem
              border={false}
              icon={
                <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                  {`${item.defaultTime} min`}
                </div>
              }
            >
              {t('scheduler.default_time_label')}
            </CBListItem>
          )}
          {expanded && (
            <>
              <CBListItem
                border={false}
                icon={
                  <div className="text-center lg:text-left lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {convertRang(item.dayRange)}
                  </div>
                }
              >
                {t('scheduler.booking_window_label')}
              </CBListItem>
              <CBListItem
                border={false}
                icon={
                  <div className="text-center lg:text-left lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {languages(t)[item.language] } {/* Pass t to languages */}
                  </div>
                }
              >
                {t('scheduler.language_label')}
              </CBListItem>
              <CBListItem
                border={false}
                icon={
                  <div className="text-center lg:text-left lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {item.militaryTime ? '24h' : '12h (am/pm)'}
                  </div>
                }
              >
                {t('scheduler.time_format_label_item')}
              </CBListItem>

              <CBListItem
                border={false}
                icon={
                  <div className="text-center lg:text-left lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {item.sundayStart ? 'Sunday' : 'Monday'}
                  </div>
                }
              >
                {t('scheduler.first_day_of_week_label_item')}
              </CBListItem>
              <CBListItem
                border={false}
                icon={
                  <div className="text-center lg:text-left lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {convertToMinHourThing(item.leadTime)},{' '}
                    {convertToMinHourThing(item.bufferBefore)},{' '}
                    {convertToMinHourThing(item.bufferAfter)}{' '}
                  </div>
                }
              >
                {t('scheduler.lead_time_buffer_label')}
              </CBListItem>

              <CBListItem
                border={false}
                icon={
                  <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {item.questions.length}
                  </div>
                }
              >
                {t('scheduler.questions_label')}
              </CBListItem>
              <CBListItem
                border={false}
                icon={
                  <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {item.integrations.length == 0 && !item.meeting && 'None'}
                    {item.integrations.length > 0 && 'Zoom'}{' '}
                    {item.meeting && item.integrations.length > 0 && ' or '}{' '}
                    {item.meeting && (
                      <>{item.type == 'google' ? 'Google Meet' : 'MS Teams'}</>
                    )}
                  </div>
                }
              >
                {t('scheduler.online_meeting_label')}
              </CBListItem>

              {item.questions.length > 0 && (
                <CBList>
                  {item.questions.map((e, index) => { // Added index for key
                    return <CBListItem key={index}>{e}</CBListItem> // Added key prop
                  })}
                </CBList>
              )}

              <CBListItem
                border={false}
                icon={
                  <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                    {item.others.length}
                  </div>
                }
              >
                {t('scheduler.additional_calendars_label')}
              </CBListItem>
              {item.additionalAttendees.length > 0 && (
                <CBListItem
                  border={false}
                  icon={
                    <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                      {item.additionalAttendees.split(',').length}
                    </div>
                  }
                >
                  {t('scheduler.additional_attendees_label_item')}
                </CBListItem>
                )}
                {item.timeMatrix['Mon'] && (
                <CBList>
                  {item.dayOptions.split(',').map((d) => {
                    var dayName = d.charAt(0).toUpperCase() + d.slice(1)
                    var times = item.timeMatrix[dayName]
                    if (times) {
                      return (
                        <CBListItem
                          key={dayName} // Added key prop
                          label={dayName}
                          icon={
                            <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                              {moment({
                                hour: times.startHour,
                                minute: times.startMin,

                        // tz: item.tz
                              }).format('h:mm a')}{' '}
                              -{' '}
                              {moment({
                                hour: times.endHour,
                                minute: times.endMin,

                        // tz: item.tz
                              }).format('h:mm a')}
                            </div>
                          }
                        >
                          {dayName}
                        </CBListItem>
                      )
                    } else {
                      return <></> // Consider returning null instead
                    }
                  })}
                </CBList>
              )}
              {!item.timeMatrix['Mon'] && (
                <CBListItem
                  icon={
                    <div className="lg:bg-white rounded-full pl-4 pr-4 pt-1 pb-1">
                      {' '}
                      {moment({
                        hour: item.startHour,
                        minute: item.startMin,
                        // tz: item.tz
                      }).format('h:mm a')}{' '}
                      to{' '}
                      {moment({
                        hour: item.endHour,
                        minute: item.endMin,
                        // tz: item.tz
                      }).format('h:mm a')}
                    </div>
                  }
                >
                  {item.dayOptions.split(',').map((d) => (
                    <span key={d}>
                      {d.charAt(0).toUpperCase() + d.slice(1)}{' '}
                    </span>
                  ))}
                </CBListItem>
              )}
            </>
          )}
          {!preview && (
            <CBListItem
              onClick={(e) => {
                setExpanded(!expanded)
              }}
              border={false}
              icon={
                <div className="lg:bg-white flex flex-row items-center justify-center gap-x-2 rounded-full pl-4 pr-4 pt-1 pb-1 cursor-pointer"> {/* Added cursor-pointer */}
                  {!expanded ? t('scheduler.more_button') : t('scheduler.less_button')}{expanded ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 mt-1"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 mt-1"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                )}
                </div>
              }
            ></CBListItem>
          )}

          {/* Removed commented out CBListItems */}

        </div>
      </div>
      {!preview && <div className="relative"><div className="absolute bottom-8 right-0">{renderMenu()}</div></div>}

      {/* Delete Confirmation Modal */}
      <CBModal
        title={t('scheduler.delete_confirm_title')}
        visible={showDeleteModal}
        onPositiveClick={handleDeleteConfirm}
        onCancelClick={() => setShowDeleteModal(false)}
        positiveLabel={t('common.delete_button')}
        negativeLabel={t('common.cancel_button')}
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }} // Danger styling
      >
        <div className="flex items-center">
          <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-xl mr-3" />
          {/* Assuming a generic confirmation message is okay */}
          <div>{t('scheduler.delete_confirm_message')}</div> {/* Use translation key */}
        </div>
      </CBModal>
    </>
  );
}

export default ScheduleItem;
